import { auth } from '@/shared/lib';
import classNames from 'classnames';
import _ from 'lodash';
import { t } from 'ttag';
import { useEcgSlider } from './useEcgSlider';
import ImageECG from './imageECG';
import InfoECG from './infoECG';
import InfoECGSelection from './infoECGSelection';
import type { ECGSliderProps } from './ecgSlider.types';

const EMPTY_ARRAY: any[] = [];

const ECGSlider = ({
  isEventAdvance = false,
  conflictUsers = EMPTY_ARRAY,
  infoData,
  isNotCanEdit,
  hasIcon = false,
  hasColorBorder = false,
  eventId,
}: ECGSliderProps) => {
  const { forceRerender } = useEcgSlider();

  return (
    <div
      className={classNames(
        'list-item-ecg-slider',
        isEventAdvance ? 'ecg-slider-selection' : '',
        hasColorBorder ? '--has-color-border' : '',
      )}
    >
      {isEventAdvance ? (
        <InfoECGSelection data={infoData} eventId={eventId} />
      ) : (
        <InfoECG
          data={infoData}
          conflictUsers={conflictUsers}
          isNotCanEdit={isNotCanEdit}
          hasIcon={hasIcon}
        />
      )}

      <ImageECG
        canExpand={isEventAdvance}
        stripImgs={infoData.stripImgs}
        hasSmallWidth={isEventAdvance}
        eventId={eventId}
        forceRerender={forceRerender}
        isNoEcgData={infoData.isNoEcgData}
        study={infoData.study}
      />

      {infoData.hasAIPredict && auth.canUseAiViewer() && (
        <div className="ai-suggest-container">
          <strong>{t`AI suggest`}:</strong>
          <div className="suggest-list-container">
            {_.map(infoData.aiSuggestArray, (suggest, index) => (
              <div
                key={index}
                className={classNames(
                  'suggest-item',
                  index !== infoData.aiSuggestArray.length - 1 ? 'mr-12' : '',
                )}
              >
                {suggest}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ECGSlider;
